export function getDealFromRefetchResult<TDeal>(
  refetchResult: { data?: { deal?: TDeal | null } } | null | undefined,
  currentDeal: TDeal | null | undefined
): TDeal | null | undefined {
  return refetchResult?.data?.deal ?? currentDeal
}
